import classNames from "classnames";
import { Button } from "PFComponents/button";

import css from "./options.module.scss";

export type Option = {
  item: {
    start: string;
    end: string;
  };
  id: string;
  displayElement: string;
  subtitle?: string;
  alternativeStyling?: boolean;
  noAction?: boolean;
  selected?: boolean;
};

type OptionsProps = {
  options: Option[];
  onSelect: (option: Option) => void;
};

export const Options = ({ options, onSelect }: OptionsProps) => (
  <div className={css.sidePanel}>
    {options.map((option) => (
      <Button
        key={option.id}
        kind="blank"
        className={classNames(css.option, {
          [css.selected]: option.selected,
          [css.noAction]: option.noAction
        })}
        onClick={() => onSelect(option)}
      >
        <div className={css.container}>
          {option.displayElement}
          {option.subtitle && <span className={css.secondary}>{option.subtitle}</span>}
        </div>
      </Button>
    ))}
  </div>
);
